import { render, staticRenderFns } from "./FilterPriceInput.vue?vue&type=template&id=6a0f3d6e&scoped=true&"
import script from "./FilterPriceInput.vue?vue&type=script&lang=js&"
export * from "./FilterPriceInput.vue?vue&type=script&lang=js&"
import style0 from "./FilterPriceInput.vue?vue&type=style&index=0&id=6a0f3d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f3d6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0f3d6e')) {
      api.createRecord('6a0f3d6e', component.options)
    } else {
      api.reload('6a0f3d6e', component.options)
    }
    module.hot.accept("./FilterPriceInput.vue?vue&type=template&id=6a0f3d6e&scoped=true&", function () {
      api.rerender('6a0f3d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FilterPriceInput.vue"
export default component.exports